const { postJson } = require("./utils");

export const auth = hmac => postJson("/auth/manager", { hmac });
